<form [formGroup]="form">
    <mat-form-field *ngIf="field.type != 'select-key'" appearance="outline">
        <mat-label>{{field.label}}</mat-label>
        <input type="text" matInput [formControlName]="field.fieldName" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="dataSelected($event)">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                {{option[nameFilter] }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-form-field *ngIf="field.type == 'select-key'" appearance="outline">
        <mat-label>{{field.label}}</mat-label>
        <input type="text" matInput [formControlName]="field.fieldName" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="dataSelected($event, 'key')">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                {{option[nameFilter] }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</form>